import {useNavigate} from 'react-router-dom';
import {
    CLEAR_ELEMENT_CLICKED,
    CLOCK_TICK,
    CLOSE_ASK_TO_END_PRESENTATION,
    END_PRESENTATION,
    HANDLE_ELEMENTS_CLICKED,
    IClearElementClickedAction,
    IClockTickAction,
    ICloseEndPresentationAction,
    IEndPresentationAction,
    IOpenEndPresentationAction,
    ISetElementsClickedAction,
    OPEN_ASK_TO_END_PRESENTATION,
    SET_ELEMENTS_CLICKED,
} from './types/chalkBoardElements.actions.types';
import {IHandleElementsClicked} from './types/dashboard.actions.type';

export const setElementsClickedAction = (clickedElementIds: string[]): ISetElementsClickedAction => ({
    type: SET_ELEMENTS_CLICKED,
    payload: clickedElementIds,
});

export const clearElementClickedAction = (): IClearElementClickedAction => ({
    type: CLEAR_ELEMENT_CLICKED,
});

export const handleElementsClickedAction = (clickedElementIds: string[], clearBeforeClick: boolean): IHandleElementsClicked => ({
    type: HANDLE_ELEMENTS_CLICKED,
    payload: {
        clickedElementIds,
        clearBeforeClick,
    },
});

export const openEndPresentationAction = (): IOpenEndPresentationAction => ({
    type: OPEN_ASK_TO_END_PRESENTATION,
});

export const closeEndPresentationAction = (): ICloseEndPresentationAction => ({
    type: CLOSE_ASK_TO_END_PRESENTATION,
});

export const endPresentationAction = (navigate: ReturnType<typeof useNavigate>): IEndPresentationAction => ({
    type: END_PRESENTATION,
    payload: navigate,
});

export const clockTickAction = (): IClockTickAction => ({
    type: CLOCK_TICK,
});
